import * as GlobalService from "../../react/global_services";
import axios from "axios";
var isFirstTimeOpen = true;
var keyName = "AuditInventory";
var metaDataAuditInventoryObject = {
    "AuditInventory": {
        "filterData": {},
        "gridConfig": "",
        "reviewgridConfig": {},
    },
};
export const getAuditInventoryClientMetaData = function () {
    if (isFirstTimeOpen) {
        return GlobalService.getUserClientMetaData(keyName).then(
            function successCallBack(response) {
                if (response !== "") {
                    Object.assign(metaDataAuditInventoryObject[`${keyName}`], JSON.parse(response));
                }
                isFirstTimeOpen = false;
                return true;
            },
            function errorCallBack(response) {
                return false;
            }
        );
    }
    return true;
};
export const gridPageSize = 1000;

export const auditOptions = function (facilityUri: string) {
    return axios.get(`/WebUI/Inventory/ManageAudits/AuditOptions?facilityUri=${facilityUri}`).then(function (response) {
        return response;
    });
};

export const blankAuditOptions = function (facilityUri: string) {
    return axios
        .get(`/WebUI/Inventory/ManageAudits/AuditOptions?facilityUri=${facilityUri}&pgsiz=1&pgnum=1`)
        .then(function (response) {
            return response;
        });
};

export const getTotalAuditOptionsCount = function (facilityUri) {
    return axios
        .get(`/WebUI/Inventory/ManageAudits/FilteredRowCount?facilityUri=${facilityUri}`)
        .then(function (response) {
            return response;
        });
};
export const auditSearchInfo = function (searchData) {
    return axios
        .put("/WebUI/Inventory/UpdateSession/AuditSearchInfo", { "searchInfo": searchData })
        .then(function (response) {
            return response;
        });
};

export const auditJob = function (param, facilityUri, type) {
    let url = "/WebUI/inventory/editaudits/audit";
    if (type === "Create") {
        return axios.post(url, { auditView: param, facilityUri: facilityUri }).then((response: any) => {
            return response;
        });
    } else {
        return axios.put(url, param).then((response: any) => {
            return response;
        });
    }
};

export const auditJobSummaryData = function (auditUri: string) {
    let url = "/WebUI/Inventory/ManageAudits/GetAuditSummary?auditUri=";
    return axios.get(url + auditUri).then((response: any) => {
        return response;
    });
};

export const exportMultiJobCSVSummary = function (auditUris: string[]) {
    let url = "/WebUI/Inventory/EditAudits/ExportAuditInventoryJobSummaryCsv";
    return axios.post(url, { auditUris: auditUris }, { responseType: "blob" }).then((response: any) => {
        const contentType = response.headers["content-type"] || "text/csv;charset=utf-8";
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "AuditInventoryJobSummary";
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (fileNameMatch && fileNameMatch[1]) {
                fileName = fileNameMatch[1].replace(/['"]/g, "");
            }
        }
        GlobalService.downloadFileBaseOnContentType(response.data, contentType, fileName, true);
        return response;
    });
};

export const closeJob = function (auditUris) {
    let url = "/WebUI/Inventory/ManageAudits/Close";
    return axios.put(url, { "auditUris": auditUris }).then((response: any) => {
        return response;
    });
};

export const locationGridSearchInfoSend = function (searchData) {
    return axios.put("/WebUI/Inventory/UpdateSession/AuditLocationSearchInfo", searchData).then(function (response) {
        return response;
    });
};

export const setAuditInventoryFilterMetaData = function (filterData) {
    metaDataAuditInventoryObject.AuditInventory.filterData = filterData;
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataAuditInventoryObject.AuditInventory));
};

export const getAuditInventoryFilterMetaData = function () {
    if (!$.isEmptyObject(metaDataAuditInventoryObject?.AuditInventory?.filterData)) {
        return metaDataAuditInventoryObject.AuditInventory.filterData;
    } else {
        return "";
    }
};
export const setAuditInventoryGridOptionInMetaData = function (gridConfig) {
    metaDataAuditInventoryObject.AuditInventory.gridConfig = gridConfig.optionsData;
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataAuditInventoryObject.AuditInventory));
};
export const getAuditInventoryGridOptionInMetaData = function () {
    if (!$.isEmptyObject(metaDataAuditInventoryObject?.AuditInventory?.gridConfig)) {
        return metaDataAuditInventoryObject.AuditInventory.gridConfig;
    } else {
        return "";
    }
};

export const clearAuditInventoryFilterMetaData = function () {
    metaDataAuditInventoryObject.AuditInventory.filterData = {};
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataAuditInventoryObject.AuditInventory));
};

export const locationGridReadData = function (dataPayload: any) {
    const url =
        dataPayload.auditType === "Location"
            ? "/WebUI/Inventory/EditAudits/AuditLocationsGridRead"
            : "/WebUI/Inventory/EditAudits/ItemAuditLocationsGridRead";
    return axios.post(url, dataPayload).then(function (response) {
        return response;
    });
};

export const setAuditInventoryreviewGridOptionInMetaData = function (gridConfig) {
    metaDataAuditInventoryObject[`${keyName}`]["reviewgridConfig"] = gridConfig.optionsData;
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataAuditInventoryObject[`${keyName}`]));
};
export const getAuditInventoryreviewGridOptionInMetaData = function () {
    if (!$.isEmptyObject(metaDataAuditInventoryObject[`${keyName}`]["reviewgridConfig"])) {
        return metaDataAuditInventoryObject[`${keyName}`]["reviewgridConfig"];
    } else {
        return "";
    }
};

export const getAuditDetails = async (auditUri: string): Promise<any> => {
    const response = await axios.get(`/WebUI/Inventory/editaudits/Audit?auditUri=${auditUri}`);
    return response.data;
};

export const saveBatchAuditJob = function (param) {
    return axios.post("/WebUI/Inventory/AuditBatches/CreateBatch", param).then((response: any) => {
        return response;
    });
};
export const getOpenBatchs = function (facilityId) {
    return axios.get(`/WebUI/Inventory/AuditBatches/GetOpenBatches?facilityId=${facilityId}`).then(function (response) {
        return response;
    });
};
export const editBatch = function (param) {
    return axios.put("/WebUI/Inventory/AuditBatches/EditBatch", param).then((response: any) => {
        return response;
    });
};

export const deteleAudit = function (auditUris) {
    return axios.put("/WebUI/inventory/editaudits/DeleteAudits", { "audituris": auditUris }).then(function (response) {
        return response;
    });
};
